import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import Service from '../../store/service'

export const getYearOperation = createAsyncThunk(
  'portfolioInsights/segment/yearDistribution/getYearOperation',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getYearOperation(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportYearOperation = createAsyncThunk(
  'portfolioInsights/segment/yearDistribution/exportYearOperation',
  async (params) => {
    const response = await Service.exportYearOperation(params)
    handleExport(response.data, response.filename)
  },
)
